/*
 *
 * AttendanceControl constants
 *
 */

// LOAD
export const LOAD_ATTENDANCECONTROL =
  'app/AttendanceControl/LOAD_ATTENDANCECONTROL';
export const LOAD_ATTENDANCECONTROL_SUCCESS =
  'app/AttendanceControl/LOAD_ATTENDANCECONTROL_SUCCESS';
export const LOAD_ATTENDANCECONTROL_ERROR =
  'app/AttendanceControl/LOAD_ATTENDANCECONTROL_ERROR';

// CHANGE/UPDATE
export const CHANGE_ATTENDANCECONTROL = 'app/AttendanceControl/CHANGE_ATTENDANCECONTROL';
export const CHANGE_ATTENDANCECONTROL_SUCCESS = 'app/AttendanceControl/CHANGE_ATTENDANCECONTROL_SUCCESS';
export const CHANGE_ATTENDANCECONTROL_ERROR = 'app/AttendanceControl/CHANGE_ATTENDANCECONTROL_ERROR';

export const FLUSH_STATE_ATTENDANCECONTROL ='app/AttendanceControl/FLUSH_STATE_ATTENDANCECONTROL';

export const LOAD_COURSE = 'app/AttendanceControl/LOAD_COURSE';
export const LOAD_COURSE_SUCCESS = 'app/AttendanceControl/LOAD_COURSE_SUCCESS';
export const LOAD_COURSE_ERROR = 'app/AttendanceControl/LOAD_COURSE_ERROR';
